import { colors, radius, shadows, spacing, typography } from "./tokens";

export const pageShellStyle = {
  display: "grid",
  gap: spacing.xl,
  padding: spacing.xl * 2,
  boxSizing: "border-box",
};

export const pageHeaderStyle = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: spacing.md,
  flexWrap: "wrap",
};

export const pageHeaderTitleBlockStyle = {
  display: "grid",
  gap: spacing.xs,
};

export const pageTitleStyle = {
  margin: 0,
  fontSize: typography.size.xl,
  lineHeight: typography.lineHeight.compact,
  color: colors.text,
  fontWeight: typography.weight.bold,
};

export const pageSubtitleStyle = {
  margin: 0,
  fontSize: typography.size.sm,
  color: colors.textMuted,
};

export const pageHeaderActionsStyle = {
  display: "flex",
  alignItems: "center",
  gap: spacing.sm,
  flexWrap: "wrap",
};

export const surfaceCardStyle = {
  background: colors.surface,
  border: `1px solid ${colors.border}`,
  borderRadius: radius.lg,
  boxShadow: shadows.sm,
  minWidth: 0,
};

export const surfaceCardHeaderStyle = {
  padding: `${spacing.md + spacing.sm}px ${spacing.xl + spacing.sm}px`,
  borderBottom: `1px solid ${colors.border}`,
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: spacing.md,
  flexWrap: "wrap",
};

export const surfaceCardBodyStyle = {
  padding: spacing.xl + spacing.sm,
};

export const sectionHeaderStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: spacing.sm,
  flexWrap: "wrap",
};

export const toolbarStyle = {
  display: "flex",
  alignItems: "center",
  gap: spacing.sm,
  flexWrap: "wrap",
};

export const asymmetricSplitLayoutStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: spacing.xl,
  alignItems: "flex-start",
};
